



































































































































































































































import {Component, Vue} from 'vue-property-decorator';
import {Getter, Mutation} from 'vuex-class';
import VButton from '@/components/VButton.vue';
import SubscriptionInfo from '@/interfaces/subscriptionInfo';

@Component({components: {VButton}})
export default class MenuBar extends Vue {
  @Getter('isLoggedIn', {namespace: 'account'}) private isLoggedIn!: boolean;
  @Mutation('LOGOUT', {namespace: 'account'}) private logout!: () => void;
  @Getter('subscriptionInfo', { namespace: 'account' }) private subscriptionInfo!: SubscriptionInfo;

  private showMobileDropdown = false;
  private manualUrl = process.env.VUE_APP_MANUAL_URL;

  private handleLogout() {
    this.logout();
    this.$router.push({name: 'login'});
  }

  private handleScroll(evt: Event, el: HTMLElement) {
    if (window.scrollY > 100) {
      el.classList.add('open');
    } else {
      el.classList.remove('open');
    }
  }
}
